import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CaseOpenFromAlert } from 'app/models/cases/cases-list.model';

@Component({
  selector: 'app-request-open-case',
  templateUrl: './request-open-case.component.html',
  styleUrls: ['./request-open-case.component.scss']
})
export class RequestOpenCaseComponent implements OnInit {

  @Output()
  openCaseData: EventEmitter<CaseOpenFromAlert> = new EventEmitter<CaseOpenFromAlert>();

  form: UntypedFormGroup;
  summaryInputLenght = 0;
  titleInputLenght = 0;
  maxLength = 1024;

  constructor(
    private fb: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      caseSummary: ['', [Validators.required, Validators.maxLength(1024)]],
      caseTitle: ['', [Validators.required, Validators.maxLength(1024)]] 
    });

    this.form.valueChanges.subscribe(
      change => {
        this.openCaseData.emit(change);
        this.titleInputLenght = this.form.get('caseTitle').value?.length;
        this.summaryInputLenght = this.form.get('caseSummary').value?.length;
      }
    );
  }

}
